import toast from "react-hot-toast";
import axiosInstance from "./Axios";
import { clientRoutes } from "../routes";

export class FontApi {
  static getAgencyFontsList = async ({
    page,
    search,
    agency_id,
    status,
    start_date,
    end_date,
  }: {
    page: number;
    search: string;
    agency_id?: string;
    status?: string;
    start_date?: string;
    end_date?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/agency_fonts`, {
        params: {
          page,
          limit: 20,
          search,
          agency_id,
          status,
          startDate: start_date,
          endDate: end_date,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyFontById = async (font_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/agency_fonts/${font_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgencyFontVariants = async (font_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/agency_fonts/${font_id}/variants`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgenciesWithFonts = async (search: string = "") => {
    try {
      const res = await axiosInstance.get(
        `admin/agency_fonts/get-agencies-with-fonts`,
        {
          params: { search },
        },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteAgencyFont = async (font_id: string) => {
    try {
      const res = await axiosInstance.delete(`admin/agency_fonts/${font_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateAgencyFontStatus = async (font_id: string, status: string) => {
    try {
      const res = await axiosInstance.patch(
        `admin/agency_fonts/${font_id}/status`,
        { status },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateAgencyFontVariantStatus = async (
    variant_id: string,
    status: string,
  ) => {
    try {
      const res = await axiosInstance.patch(
        `admin/agency_fonts/variants/${variant_id}/status`,
        { status },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteAgencyFontVariant = async (variant_id: string) => {
    try {
      const res = await axiosInstance.delete(
        `admin/agency_fonts/variants/${variant_id}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getBrandFontsList = async ({
    page,
    search,
    brand_id,
    status,
    start_date,
    end_date,
  }: {
    page: number;
    search: string;
    brand_id?: string;
    status?: string;
    start_date?: string;
    end_date?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/brand_fonts`, {
        params: {
          page,
          limit: 20,
          search,
          brand_id,
          status,
          startDate: start_date,
          endDate: end_date,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getBrandFontById = async (font_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/brand_fonts/${font_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getBrandFontVariants = async (font_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/brand_fonts/${font_id}/variants`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getBrandsWithFonts = async (search: string = "") => {
    try {
      const res = await axiosInstance.get(
        `admin/brand_fonts/get-brands-with-fonts`,
        {
          params: { search },
        },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteBrandFont = async (font_id: string) => {
    try {
      const res = await axiosInstance.delete(`admin/brand_fonts/${font_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateBrandFontStatus = async (font_id: string, status: string) => {
    try {
      const res = await axiosInstance.patch(
        `admin/brand_fonts/${font_id}/status`,
        { status },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateBrandFontVariantStatus = async (
    variant_id: string,
    status: string,
  ) => {
    try {
      const res = await axiosInstance.patch(
        `admin/brand_fonts/variants/${variant_id}/status`,
        { status },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteBrandFontVariant = async (variant_id: string) => {
    try {
      const res = await axiosInstance.delete(
        `admin/brand_fonts/variants/${variant_id}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getSystemFontsList = async ({
    page,
    search,
    status,
    start_date,
    end_date,
  }: {
    page: number;
    search: string;
    status?: string;
    start_date?: string;
    end_date?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/system_fonts`, {
        params: {
          page,
          limit: 20,
          search,
          status,
          startDate: start_date,
          endDate: end_date,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getSystemFontById = async (font_id: string) => {
    try {
      const res = await axiosInstance.get(`admin/system_fonts/${font_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getSystemFontVariants = async (font_id: string) => {
    try {
      const res = await axiosInstance.get(
        `admin/system_fonts/${font_id}/variants`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteSystemFont = async (font_id: string) => {
    try {
      const res = await axiosInstance.delete(`admin/system_fonts/${font_id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateSystemFontStatus = async (font_id: string, status: string) => {
    try {
      const res = await axiosInstance.patch(
        `admin/system_fonts/${font_id}/status`,
        { status },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateSystemFontVariantStatus = async (
    variant_id: string,
    status: string,
  ) => {
    try {
      const res = await axiosInstance.patch(
        `admin/system_fonts/variants/${variant_id}/status`,
        { status },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static deleteSystemFontVariant = async (variant_id: string) => {
    try {
      const res = await axiosInstance.delete(
        `admin/system_fonts/variants/${variant_id}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getVariantsByPostscriptNames = async (postscript_names: string[]) => {
    try {
      const res = await axiosInstance.post(
        `admin/system-fonts/query-by-postscript-names`,
        { postscript_names },
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status || err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };
}
